import React from "react"
import styled from "styled-components"

export const Header = () => {
  return (
    <Hero>
      <Eyebrow>Anteckningar</Eyebrow>
      <Title>Kod, servrar och hur saker sitter ihop.</Title>
      <Lead>
        Khaled El Hamzi skriver om .NET, Next.js och webbdesign — korta
        handledningar från verkliga projekt, på svenska.
      </Lead>
    </Hero>
  )
}

const Hero = styled.header`
  grid-column: 1 / -1;
  width: min(80rem, calc(100% - 3rem));
  max-width: 42rem;
  margin: 0 auto;
  padding: 3rem 0 1.5rem;
`

const Eyebrow = styled.p`
  font-size: 0.8125rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--muted);
`

const Title = styled.h1`
  margin-top: 0.75rem;
  font-family: var(--font-serif);
  font-size: clamp(2.2rem, 5vw, 3.4rem);
  font-weight: 600;
  letter-spacing: -0.035em;
  line-height: 1.12;
`

const Lead = styled.p`
  margin-top: 1.1rem;
  color: var(--muted);
  font-size: 1.125rem;
  line-height: 1.65;
`
